import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <p className="logo-main">Adhunik Prefab Systems</p>
          <p>
            Leading manufacturers of customizable porta cabins, site offices, false ceilings,
            and prefabricated structures — built for speed, durability, and your exact needs.
          </p>
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/productservices">Products & Services</Link></li>
            <li><Link to="/clients">Our Clients</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <p>7, Jai Bhawani Market Atta, Sec 27</p>
          <p>Noida 201301, India</p>
          <p>
            <a href="mailto:contact@adhunikprefabsystem.com">contact@adhunikprefabsystem.com</a>
          </p>
          <p>
            <a href="tel:+919810558596">+91 98105 58596</a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Adhunik Prefab Systems. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
